import type { GetLibraryItemsParams, LibraryItemsResponse } from './types';

import { BASE_URL } from '../constants';
import { get } from '../requestMethods';

export const CONTENT_API = {
  getLibraryItems: (params: GetLibraryItemsParams) => get<LibraryItemsResponse>(`${BASE_URL}/api/content`, { params }),
};
